import React from "react";
import LandscapeProgramLayout from "../LandscapeProgramLayout";
import BottomNav from "../BottomNav";
import { useAuthContext } from "../../../context/auth";
import useCountDown from "../../../hooks/useCountDown";
import CircuitDemo from "./CircuitDemo";
import WeightDemo from "./WeightDemo";
import NewCircuitDemo from "./NewCircuitDemo";
import HiluxDemo from "../Hilux/HiluxDemo";

function LandscapeDemo() {
  const { circuitProgram, weightProgram, hiluxProgram } = useAuthContext();

  const getScreen = () => {
    if (hiluxProgram?.programType === "HILUX") return <HiluxDemo />;
    return circuitProgram?.programType === "BOOSTER" ? (
      <CircuitDemo />
    ) : circuitProgram?.programType === "CIRCUIT" ? (
      <NewCircuitDemo />
    ) : (
      <WeightDemo />
    );
  };

  return (
    <LandscapeProgramLayout step={3}>
      <div className="h-full">
        <div className="flex h-full">
          <div
            className="flex-1 h-full flex"
            style={
              hiluxProgram?.programType === "HILUX"
                ? undefined
                : {
                    background: `url("./Trainer-Girl.png")`,
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                  }
            }
          >
            {getScreen()}
          </div>
        </div>
      </div>
      <BottomNav />
    </LandscapeProgramLayout>
  );
}

export default LandscapeDemo;
